import { render, staticRenderFns } from "./TabelaAprovacaoCampanhas.vue?vue&type=template&id=322a66c8&scoped=true&"
import script from "./TabelaAprovacaoCampanhas.vue?vue&type=script&lang=js&"
export * from "./TabelaAprovacaoCampanhas.vue?vue&type=script&lang=js&"
import style0 from "./TabelaAprovacaoCampanhas.vue?vue&type=style&index=0&id=322a66c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322a66c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBadge,VBtn,VChip,VDivider,VIcon,VSpacer,VTextField,VToolbar,VToolbarTitle,VTooltip})
